import type { SButtonParams, SButtonReturn, StoryblokLink } from '../types';

interface ActionHandlers {
  'anchor-scroll': (params: { anchorName: string | null }) => () => void;
  'id-scroll': (params: { elementId: string }) => () => void;
}

type ActionType = keyof ActionHandlers | 'url-link';

export const actions: ActionHandlers = {
  'anchor-scroll':
    ({ anchorName }: { anchorName: string | null }) =>
    () =>
      document.getElementsByName(anchorName || '')?.[0]?.scrollIntoView(),
  'id-scroll':
    ({ elementId }: { elementId: string }) =>
    () =>
      document.getElementById(elementId)?.scrollIntoView()
};

export default function (data: SButtonParams): SButtonReturn {
  const listeners: Record<string, () => void> = {};
  const action = data?.action?.[0];

  if (!action) {
    return {
      module: 'SButton',
      ...data
    };
  }

  const actionHandler = action.component?.replace('n-button--', '') as ActionType | undefined;

  if (actionHandler && actionHandler in actions && actionHandler !== 'url-link') {
    listeners.click = actions[actionHandler](action as any);
  }

  if (actionHandler === 'url-link') {
    const link = action.link as StoryblokLink;
    if (link.linktype === 'url') {
      const url = link.anchor && String(link.anchor).length ? `${link.url}#${link.anchor}` : link.url;
      data.link = url;
      data.href = url;
    } else {
      const to = {
        path: `/${link.cached_url}/`,
        hash: link.anchor && String(link.anchor).length ? `#${link.anchor}` : null
      };
      data.to = to;
    }
  }

  data.id = data.id === '' ? null : data.id;

  return {
    module: 'SButton',
    ...data,
    slots: {
      default: data.text
    },
    listeners,
    actionHandler
  };
}
